export const services = [
    {
        "title" : "Free Shipping",
        "tagline" : "From all orders over Kshs 1,000.",
        "image" : "images/service.png",
    },
    {
        "title" : "Daily Surprise Offers",
        "tagline" : "Save up to 25% off.",
        "image" : "images/service-02.png",
    },
    {
        "title" : "Support 24/7",
        "tagline" : "Shop with an expert.",
        "image" : "images/service-03.png",
    },
    {
        "title" : "Affordable prices",
        "tagline" : "Get factory default prices.",
        "image" : "images/service-04.png",
    },
    {
        "title" : "Secure Payments",
        "tagline" : "100% Protected Payment.",
        "image" : "images/service-05.png",
    }
]